export const CANNOT_BE_BLANK = 'Cannot be blank'
export const INVALID_EMAIL = 'Invalid email address'
export const INCORRECT_PASSWORD_LENGTH = 'Password must be between 6 and 64 characters'
export const INCORRECT_CONFIRM_PASSWORD_DOES_NOT_MATCH = 'Confirmation password does not match'
